"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var IncludedAppsIcon = function IncludedAppsIcon(_ref) {
  var includedApps = _ref.includedApps;
  if (!includedApps) return null;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "end"
  }, includedApps.map(function (app) {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        right: 2
      },
      key: app.id
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Image, {
      alt: app.type,
      sm: {
        src: app.url,
        width: '30px'
      }
    }));
  }));
};
IncludedAppsIcon.propTypes = {
  includedApps: _propTypes.default.array
};
var _default = IncludedAppsIcon;
exports.default = _default;